import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { Referral } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ReferralService {
  constructor(private httpService: HttpClient, private config: ConfigService) {}

  readOneByHash(hash: number | string) {
    const url = this.config
      .getUrl('user.getReferral')
      .replace(':hash', hash.toString());
    return this.httpService.get(url);
  }

  readFromLocalStorage(): Referral | undefined {
    try {
      const referral = localStorage.getItem('referral');

      if (referral) {
        return JSON.parse(referral);
      } else return undefined;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }
}
